import React, { useState, useEffect } from "react";
import Button from "../../common/Button/Button";
import CommunityGallery from "./CommunityGallery";
import SadaqatGallery from "./SadaqatGallery";
import OneHourGallery from "./OneHourGallery";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Projects.css";

const Projects = () => {
  const [openOneHour, setOpenOneHour] = useState(false);
  const [openCommunity, setOpenCommunity] = useState(false);
  const [openSadaqat, setOpenSadaqat] = useState(false);

  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  const openOneHourGallery = () => {
    setOpenOneHour(true);
    setOpenCommunity(false);
    setOpenSadaqat(false);
  };

  const openCommunityGallery = () => {
    setOpenOneHour(false);
    setOpenCommunity(true);
    setOpenSadaqat(false);
  };

  const openSadaqatGallery = () => {
    setOpenOneHour(false);
    setOpenCommunity(false);
    setOpenSadaqat(true);
  };

  const projects = [
    {
      title: "Sedaqat Educational Center",
      description: "Managed by Ayesha Hakimi, Sedaqat Educational Center currently serves 140 students from first to sixth grade. Located in Dasht-e-Barchi, this center provides eight hours of daily lessons in subjects such as English, Math, Pashto, and basic principles (including reading, writing, and arithmetic for grades one to three). The center employs four dedicated teachers, a manager, an assistant manager, and a guard. Monthly expenses range from $550 to $600, covering rent, utilities, staff salaries, and the distribution of stationery and books to all students.",
      onClick: openSadaqatGallery,
      delay: 100
    },
    {
      title: "Action Not Word Educational Course",
      description: "Located in the Qasaba area and managed by Walid Hoida, this comprehensive course offers lessons in religious subjects, sewing, drawing, English, and mathematics. The program provides students with both academic knowledge and practical skills that will serve them throughout their lives. The monthly operating expenses are approximately $300, supporting quality education for our students.",
      onClick: openCommunityGallery,
      delay: 200
    },
    {
      title: "One Hour for Afghanistan (OHA)",
      description: "Founded by the family of Mohammad Waris 'Azimi' and active for over seven years, OHA has become a cornerstone of educational support in the community, serving both boys and girls. The program recently established a sewing class for women to help them become self-sufficient and economically independent. Managed by Homayoun Ebrahim Khail, the monthly expenses are around $400, ensuring quality education and empowerment opportunities for all participants.",
      onClick: openOneHourGallery,
      delay: 300
    }
  ];

  return (
    <div>
      {openOneHour && <OneHourGallery isOpen={openOneHour} setIsOpen={setOpenOneHour} />}
      {openCommunity && (
        <CommunityGallery isOpen={openCommunity} setIsOpen={setOpenCommunity} />
      )}
      {openSadaqat && (
        <SadaqatGallery isOpen={openSadaqat} setIsOpen={setOpenSadaqat} />
      )}

      <h1 className="projects" data-aos="fade-down">
        <span className="projects-title-text">Our Projects</span>
      </h1>

      <div className="projects-container">
        <div className="projects-cards-container">
          {projects.map((project, index) => (
            <div 
              key={index}
              className="projects-card" 
              data-aos="fade-up"
              data-aos-delay={project.delay}
            >
              <h2>{project.title}</h2>
              <p className="projects-card-description">
                {project.description}
              </p>
              <Button
                className="btns"
                buttonStyle="btn--solid"
                buttonSize="btn--small"
                onClick={project.onClick}
              >
                VIEW GALLERY
              </Button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;